import { Type, type Static } from '@sinclair/typebox';
import { PublicWebhookEndpointSchema } from './webhook-endpoint.schema';

export const WebhookEndpointsResponseSchema = Type.Object({
  object: Type.Literal('WebhookEndpoints'),
  data: Type.Array(PublicWebhookEndpointSchema),
  has_more: Type.Boolean(),
});
export type WebhookEndpointsResponse = Static<typeof WebhookEndpointsResponseSchema>;
